<template lang="pug">
  .aside__subblock
    p.aside__subblock-desc(v-if="lessonIdx === ''")
      | Заполните данные, чтобы создать новый урок. Больше деталей сможете указать в подробных настройках.
    .aside__list
      .aside__item.-full-
        Input(
          title="Название урока"
          placeholder="Урок 1"
          :error="$v.lesson.name.$dirty && !$v.lesson.name.required"
          v-model="lesson.name"
          @input="compare"
        )
          span.form-item__error(v-if="$v.lesson.name.$dirty && !$v.lesson.required")
            | Обязательное поле

      .aside__item.-full-
        Input(
          title="Описание"
          placeholder="Отличный урок с огненным контентом"
          v-model="lesson.description"
          @input="compare"
        )

      .aside__item.-full-
        DropAsideImage(
          v-model="lesson.side.img"
          @input="compare"
        )

      .aside__item.-full-
        Input(
          title="Текст на картинке"
          placeholder="1.4"
          v-model="lesson.side.imgText"
          @input="compare"
        )

      .aside__item
        InputDate(
          title="Дата старта"
          v-model="lesson.dateOfStart"
          @input="compare"
        )

      //.aside__item
        InputDate(
          title="Крайний срок"
          placeholder="21/05/2020"
          v-model="lesson.task.ddl"
          @input="compare")

      .aside__item.-full-
        SelectMultiple(
          title="Спикеры"
          placeholder="Укажите спикера"
          :selectData="groups"
          :selectedInData="selectedInGroups"
          @updateListInGroup="updateListInGroup"
          @toggleItemInGroup="toggleItemInGroup"
        )

      .aside__item
        InputSwitch(
          v-model="lesson.isImportant"
          switchText="Важный урок"
          :hasTitle="false"
          @input="compare"
        )

      .aside__item
        InputSwitch(
          v-model="lesson.isStopLesson"
          switchText="Стоп урок"
          :hasTitle="false"
          @input="compare"
        )

      .aside__item
        InputSwitch(
          v-model="lesson.isHidden"
          switchText="Скрытый урок"
          :hasTitle="false"
          @input="compare"
        )

      .aside__item.-full-
        SelectGroups.aside__select(
          title="Группа"
          placeholder="Выберите группу"
          v-model="lesson.groups"
        )

</template>

<script>
import _ from 'lodash';
import { mapState, mapActions } from 'vuex';
import { required } from 'vuelidate/lib/validators';
import SelectGroups from './components/Select';

export default {
  components: { SelectGroups },
  data: () => ({
    lesson: {
      dateOfStart: '',
      description: '',
      isHidden: true,
      isImportant: false,
      isStopLesson: false,
      name: '',
      side: {
        img: '',
        imgText: ''
      },
      speakers: [],
      tags: [],
      task: {
        ddl: '',
        isTaskExist: true
      },
      groups: []
    },
    lessonBackup: {
      dateOfStart: '',
      description: '',
      isHidden: true,
      isImportant: false,
      isStopLesson: false,
      name: '',
      side: {
        img: '',
        imgText: ''
      },
      speakers: [],
      tags: [],
      task: {
        ddl: '',
        isTaskExist: true
      },
      groups: []
    },
    groups: {
      speakers: {
        name: 'Спикеры',
        showName: true,
        searchUrl: '/speaker/list/get',
        listClass: '',
        listItemClass: '',
        list: []
      }
    }
  }),
  computed: {
    ...mapState('coursesCourse', {
      lessonIdx: s => s.aside.data.idx,
      storeLesson: s => s.aside.data.lesson,
      canSave: s => s.aside.meta.canSave,
      copy: s => s.aside.meta.copy,
      courseGroups: s => s.data.course.groups
    }),
    selectedInGroups() {
      return {
        speakers: [...this.lesson.speakers]
      };
    }
  },
  watch: {
    'lesson.groups': function () {
      if (!_.isEqual(this.lesson.groups, this.lessonBackup.groups)) {
        this.compare();
      }
    }
  },
  beforeMount() {
    this.setData();
    this.getGroups();
  },
  destroyed() {
    this.$store.dispatch('usersGroups/setData', { path: 'folders', value: [] });
  },
  methods: {
    ...mapActions('usersGroups', ['getGroups']),
    setData() {
      if (this.lessonIdx !== '' || this.copy) {
        this.lesson = _.cloneDeep(this.storeLesson);

        if (this.copy) {
          this.$store.dispatch('coursesCourse/setAsideData', {
            path: 'stagedLesson',
            value: this.lesson
          });
          this.$store.dispatch('coursesCourse/setAsideMeta', {
            path: 'canSave',
            value: true
          });
        } else {
          this.lessonBackup = _.cloneDeep(this.lesson);
        }
      } else {
        this.lessonBackup.groups = [...this.courseGroups];
        this.lesson.groups = [...this.courseGroups];
      }
    },
    compare() {
      if (this.$v.$invalid) {
        this.$v.$touch();
        if (this.canSave) {
          this.$store.dispatch('coursesCourse/setAsideMeta', {
            path: 'canSave',
            value: false
          });
        }

        return;
      }

      const formHasChanges = !_.isEqual(this.lesson, this.lessonBackup);

      if (this.canSave !== formHasChanges) {
        this.$store.dispatch('coursesCourse/setAsideMeta', {
          path: 'canSave',
          value: formHasChanges
        });
      }
      if (this.canSave) {
        this.$store.dispatch('coursesCourse/setAsideData', {
          path: 'stagedLesson',
          value: {
            ...this.lesson,
            groups: this.lesson.groups
          }
        });
      }
    },
    updateListInGroup({ data, groupName }) {
      this.groups[groupName].list = [...data.speakers];
    },
    toggleItemInGroup({ item, groupName }) {
      if (groupName === 'speakers') {
        const itemExistedIdx = this.lesson.speakers.findIndex(s => s.id === item.id);
        if (itemExistedIdx === -1) {
          // Добавляем итем к автивным
          this.lesson.speakers.push(item);
        } else {
          this.lesson.speakers.splice(itemExistedIdx, 1);
        }
      }
      this.compare();
    }
  },
  validations: {
    lesson: {
      name: { required }
    }
  }
};
</script>
